// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background-color: var(--color-surface-strong);
  height: 50px;
}

.container {
  display: flex;
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  overflow: hidden;
}

.menu-container {
  background-color: var(--color-surface);
  padding: 5px;
  overflow-y: auto;
  width: 23%;
}

.menu-list {
  background-color: var(--color-surface-subtle);
  padding: 5px;
}

.details-container {
  background-color: var(--color-surface);
  padding: 5px;
  overflow-y: auto;
  width: 77%;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Docs/router/screens/Index/index.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":["nav {\n  background-color: var(--color-surface-strong);\n  height: 50px;\n}\n\n.container {\n  display: flex;\n  max-height: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  overflow: hidden;\n}\n\n.menu-container {\n  background-color: var(--color-surface);\n  padding: 5px;\n  overflow-y: auto;\n  width: 23%;\n}\n\n.menu-list {\n  background-color: var(--color-surface-subtle);\n  padding: 5px;\n}\n\n.details-container {\n  background-color: var(--color-surface);\n  padding: 5px;\n  overflow-y: auto;\n  width: 77%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
